{
    "ChannelCode": "코드",
    "Components": {
        "MeetingEnd": {
            "FeedbackConfirmation": {
                "ExploreMoreFeatures": "더 많은 기능 탐색",
                "ThanksMessage": "함께해 주셔서 감사합니다.",
                "WorkingMessage": "번역이 더 나은 경험을 제공했기를 바랍니다."
            },
            "FeedbackForm": {
                "FeedbackQuestion": "번역 품질은 어떠셨나요?",
                "SessionClosedMessage": "실시간 번역이 종료되었습니다.",
                "ThankYouMessage": "도움이 되었기를 바랍니다!"
            }
        }
    },
    "Continue": "계속하기",
    "Control": {
        "Original": "원문",
        "Spacing": "간격",
        "TextSize": "글자 크기",
        "Tts": "TTS"
    },
    "Download": "다운로드",
    "Idle": "유휴",
    "Join": "참여하기",
    "LanguageSettings": "언어",
    "Live": "진행 중",
    "Loading": {
        "Entering": "채널에 입장하는 중",
        "Joining": "채널에 참여하는 중"
    },
    "OK": "확인",
    "Pages": {
        "Home": {
            "EnterEventCodeMessage": "채널 코드를 입력해 주세요.",
            "InputPlaceholder": "채널 코드를 입력하세요",
            "Title": "현장에 함께하고, 모두 이해하세요."
        },
        "SelectLanguage": {
            "SearchEmpty": "일치하는 언어가 없습니다",
            "SearchPlaceholder": "언어 검색",
            "Title": "번역 언어를 선택하세요"
        }
    },
    "Pane": {
        "CatchUp": "최신으로 이동",
        "Source": "원문",
        "Translation": "번역",
        "Tts": "음성 읽기",
        "TtsShort": "TTS"
    },
    "Share": "공유하기",
    "SpeechSpeed": "말하기 속도",
    "Start": "시작",
    "Submit": "제출",
    "Tips": {
        "Error": {
            "Channel": {
                "LimitExceeded": "이 채널은 연결 한도에 도달했습니다."
            }
        },
        "Icon": {
            "ScrollToBottom": "최신으로 돌아가기",
            "ShareLink": "링크 공유",
            "SpeechRate": "재생 속도 설정"
        }
    },
    "Toast": {
        "LanguageChanged": "번역 언어: {lang}",
        "LinkCopied": "링크가 복사되었습니다",
        "SourceOff": "원문 숨김",
        "SourceOn": "원문 표시됨",
        "TtsOff": "음성 읽기 꺼짐",
        "TtsOn": "음성 읽기 켜짐"
    },
    "Transcript": {
        "Start": "기록의 시작"
    },
    "tutorialPage": {
        "downloadOverlay": {
            "originText": "원본 텍스트",
            "summary": "요약",
            "transcript": "필기록"
        },
        "translationLanguage": {
            "title": "번역 언어"
        }
    }
}
